"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ArticlesSection = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _Title = require("../Title");
var _constants = require("./constants");
var _getPaginationLoadMoreButtonVisibility = require("./getPaginationLoadMoreButtonVisibility");
var _getPaginationProgress = require("./getPaginationProgress");
var _styles = require("./styles");
var _useGetArticles = require("./useGetArticles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Returns section with instances of `ArticleBox` and `Title`.
 * Renders if there is at least 1 article in `listing` mode with thruthy data.
 * Renders if there are at least 3 articles in `featured` mode with thruthy data.
 */ const ArticlesSection = (param)=>{
    let { articles: initialArticles, className, countOfArticles, labelRead, loadMoreButtonText, mode, title, getPaginationInfoText } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { articles, loadingArticles, loadMore } = (0, _useGetArticles.useGetArticles)({
        articles: initialArticles,
        countOfArticles
    });
    const progress = (0, _getPaginationProgress.getPaginationProgress)(articles.length, countOfArticles);
    const paginationLoadMoreButtonVisible = (0, _getPaginationLoadMoreButtonVisibility.getPaginationLoadMoreButtonVisibility)(articles.length, countOfArticles);
    if (articles.length < 1) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_constants.ARTICLES_SECTION),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Title.Title, {
                title: title
            }),
            mode === 'listing' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Articles, {
                children: articles.map((param)=>{
                    let { categoryTitle, image, introText, isVideoArticle, link, title: articleTitle } = param;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.ArticleBox, {
                        labelRead: labelRead,
                        labelWatch: "",
                        categoryTitle: categoryTitle,
                        image: image,
                        introText: introText,
                        isVideoArticle: isVideoArticle,
                        link: link,
                        title: articleTitle
                    }, articleTitle);
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Carousel, {
                data: articles,
                labelRead: labelRead,
                labelWatch: "",
                id: "editorials-articles-section-carousel"
            }),
            mode === 'listing' && countOfArticles !== undefined && loadMoreButtonText && getPaginationInfoText ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Pagination, {
                button: {
                    label: loadMoreButtonText,
                    loading: loadingArticles,
                    visible: paginationLoadMoreButtonVisible,
                    onClick: loadMore
                },
                infoText: getPaginationInfoText(articles.length, countOfArticles),
                progress: progress
            }) : null
        ]
    });
};
exports.ArticlesSection = ArticlesSection;
